var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { addCustomerData, getCustomerListWithMainContact, getSalesRepBaseData, singleCustomerData } from "../../reduxStore/actions/salesRepDataAction";
import store from "../../reduxStore/store";
import { isLoading } from "../../services/behaviorSubjectService";
import { regexEmailValidation } from "../../shared/regex";
import { SharedFunctions } from "../SharedFunctions";
import { postcodeValidator } from "postcode-validator";
import { getLoggedInRepDetailsFromSession, updateExistingCustomerDataService } from "../../services/apiServices/salesRepDataService";
export function NewCustomerModalBL(props) {
    var _this = this;
    var _a, _b, _c, _d;
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var _e = SharedFunctions(), getProvinceOfShopify = _e.getProvinceOfShopify, SnackbarAlertMsg = _e.SnackbarAlertMsg;
    var salesRepId = getLoggedInRepDetailsFromSession().CustomerId;
    var _f = useState([]), provinceStates = _f[0], setProvinceStates = _f[1];
    var defaultFormValues = {
        customer_fname: "",
        customer_lname: "",
        customer_email: "",
        customer_phoneno: 0,
        customer_note: "",
        customer_address: "",
        customer_address2: "",
        customer_city: "",
        customer_country: "",
        customer_state: "",
        customer_pincode: "",
        business_name: "",
        cust_company_address: "",
        cust_company_city: "",
        cust_company_country: "",
        cust_company_state: "",
        cust_company_pincode: "",
        subTotal: 0,
        noOfOrders: 0,
        tags: "",
        addressId: "",
    };
    var _g = useState(false), createCustomerModalOpen = _g[0], setCreateCustomerModalOpen = _g[1];
    var _h = useState(defaultFormValues), addCustomerForm = _h[0], setAddCustomerForm = _h[1];
    var _j = useState(true), isAddCustomer = _j[0], setIsAddCustomer = _j[1];
    var _k = useState({ fnameErrMsg: "", emailErrMsg: "", customerPinCodeErrMsg: "", companyPinCodeErrMsg: "" }), inputState = _k[0], setInputState = _k[1];
    var _l = useState({ customerStates: "in", companyStates: "in" }), stateByCountry = _l[0], setStateByCountry = _l[1];
    var _m = useState(false), highlightRequiredFields = _m[0], setHighlightRequiredFields = _m[1];
    // Check if any field has content by comparing with default values
    var hasAnyFieldContent = function () {
        return Object.keys(defaultFormValues).some(function (key) {
            var currentValue = addCustomerForm[key];
            var defaultValue = defaultFormValues[key];
            return currentValue !== defaultValue;
        });
    };
    var submitBtnEnabled = hasAnyFieldContent();
    var _o = useState(t("submit_btn_text")), submitDataText = _o[0], setSubmitDataText = _o[1];
    var _p = useState(""), addCustomerErr = _p[0], setAddCustomerErr = _p[1];
    var _q = useState(""), addCustomerSuccess = _q[0], setAddCustomerSuccess = _q[1];
    var _r = useState(false), loadingDisabled = _r[0], setLoadingDisabled = _r[1];
    var _s = useState(false), submitLoader = _s[0], setSubmitLoader = _s[1];
    var _t = useState(""), inputValue = _t[0], setInputValue = _t[1];
    var _u = useState(true), isEditForm = _u[0], setIsEditForm = _u[1];
    var _v = useState(store.getState().salesRepData.baseData.hideCompanyAddressInAddCustomer), hideCompanySection = _v[0], setHideCompanySection = _v[1];
    var salesRepData = useSelector(function (state) { return (state.salesRepData ? state.salesRepData : {}); });
    var selectFeatures = ((_a = salesRepData.baseData) === null || _a === void 0 ? void 0 : _a.select) ? (_b = salesRepData.baseData) === null || _b === void 0 ? void 0 : _b.select : {};
    var isEditCustomer = ((_c = selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.featuresAdditionalSettings) === null || _c === void 0 ? void 0 : _c.isEditCustomerInfo) ? (_d = selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.featuresAdditionalSettings) === null || _d === void 0 ? void 0 : _d.isEditCustomerInfo : false;
    var _w = useState({ msg: "", open: false, severity: "error" }), alertErrorMsg = _w[0], setAlertErrorMsg = _w[1];
    isLoading.subscribe(function (data) {
        if (data !== loadingDisabled)
            setLoadingDisabled(data);
    });
    var changeValue = function (e, doNotReset) {
        var _a = e.target, name = _a.name, value = _a.value;
        if (!doNotReset) {
            setIsEditForm(false);
        }
        // Reset highlight state when user starts typing
        if (highlightRequiredFields) {
            setHighlightRequiredFields(false);
        }
        setAddCustomerForm(function (prevForm) {
            var _a;
            var updatedForm = __assign(__assign({}, prevForm), (_a = {}, _a[name] = value, _a));
            if ((name === "customer_country" && prevForm.customer_pincode) || (name === "cust_company_country" && prevForm.cust_company_pincode)) {
                updatedForm[name === "customer_country" ? "customer_pincode" : "cust_company_pincode"] = "";
            }
            return updatedForm;
        });
        if ((name === "customer_country" && (inputState === null || inputState === void 0 ? void 0 : inputState.customerPinCodeErrMsg)) || (name === "cust_company_country" && (inputState === null || inputState === void 0 ? void 0 : inputState.companyPinCodeErrMsg))) {
            setInputState(function (values) {
                var _a;
                return (__assign(__assign({}, values), (_a = {}, _a[name === "customer_country" ? "customerPinCodeErrMsg" : "companyPinCodeErrMsg"] = "", _a)));
            });
        }
        nameEmailValidation(name, value);
    };
    var changeCountry = function (e, country, doNotReset) {
        var value = e.target.value;
        var countryWithoutCode = value === null || value === void 0 ? void 0 : value.split("_")[0];
        setProvinceStates(getProvinceOfShopify(countryWithoutCode || ""));
        if (country === "customer_country" || country === "cust_company_country") {
            setStateByCountry(function (values) {
                var _a;
                return (__assign(__assign({}, values), (_a = {}, _a[country === "customer_country" ? "customerStates" : "companyStates"] = value ? value === null || value === void 0 ? void 0 : value.split("_")[1] : "in", _a)));
            });
        }
        changeValue(e, doNotReset);
    };
    var nameEmailValidation = function (name, value) {
        var _a, _b;
        var setError = function (field, message) {
            setInputState(function (values) {
                var _a;
                return (__assign(__assign({}, values), (_a = {}, _a[field] = message, _a)));
            });
        };
        switch (name) {
            case "customer_fname":
                if (highlightRequiredFields && value === "") {
                    setError("fnameErrMsg", t("addCustomer_leadEmptyErrrorMsg"));
                }
                else if (value !== "") {
                    setError("fnameErrMsg", "");
                }
                break;
            case "customer_email":
                if (highlightRequiredFields && value === "") {
                    setError("emailErrMsg", t("addCustomer_leadEmptyErrrorMsg"));
                }
                else if (value !== "") {
                    var emailError = value.match(regexEmailValidation) ? "" : t("email_id_validation_errmsg");
                    setError("emailErrMsg", emailError);
                }
                else {
                    setError("emailErrMsg", "");
                }
                break;
            case "customer_pincode":
                if (value === "") {
                    setError("customerPinCodeErrMsg", "");
                }
                else if ((addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_country) && (stateByCountry === null || stateByCountry === void 0 ? void 0 : stateByCountry.customerStates)) {
                    var isValidCustomerPincode = postcodeValidator(value, (_a = stateByCountry === null || stateByCountry === void 0 ? void 0 : stateByCountry.customerStates) === null || _a === void 0 ? void 0 : _a.toUpperCase());
                    setError("customerPinCodeErrMsg", isValidCustomerPincode ? "" : t("Customer_Invalid_pinCode_Msg"));
                }
                break;
            case "cust_company_pincode":
                if (value === "") {
                    setError("companyPinCodeErrMsg", "");
                }
                else if ((addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.cust_company_country) && (stateByCountry === null || stateByCountry === void 0 ? void 0 : stateByCountry.companyStates)) {
                    var isValidCompanyPincode = postcodeValidator(value, (_b = stateByCountry === null || stateByCountry === void 0 ? void 0 : stateByCountry.companyStates) === null || _b === void 0 ? void 0 : _b.toUpperCase());
                    setError("companyPinCodeErrMsg", isValidCompanyPincode ? "" : t("Customer_Invalid_pinCode_Msg"));
                }
                break;
            default:
                break;
        }
    };
    var customerFullAddress = function () {
        var _a;
        var customer_address = addCustomerForm.customer_address, customer_address2 = addCustomerForm.customer_address2, customer_city = addCustomerForm.customer_city, customer_state = addCustomerForm.customer_state, customer_country = addCustomerForm.customer_country, customer_pincode = addCustomerForm.customer_pincode;
        return (_a = [customer_address, customer_address2, customer_city, customer_state, customer_country, customer_pincode]) === null || _a === void 0 ? void 0 : _a.filter(Boolean).join(", ");
    };
    var removeMessages = function () {
        setAddCustomerErr("");
        setAddCustomerSuccess("");
        setAlertErrorMsg({ msg: "", open: false, severity: "success" });
        setHighlightRequiredFields(false);
        setInputState({ fnameErrMsg: "", emailErrMsg: "", customerPinCodeErrMsg: "", companyPinCodeErrMsg: "" });
    };
    var getSingleCustomerData = function (clientId) { return __awaiter(_this, void 0, void 0, function () {
        var singleCustomerResponseData, responseData;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    removeMessages();
                    setIsAddCustomer(false);
                    setAddCustomerErr("");
                    setAlertErrorMsg({ msg: "", open: false, severity: "success" });
                    isLoading.next(true);
                    return [4 /*yield*/, dispatch(singleCustomerData(clientId))];
                case 1:
                    singleCustomerResponseData = _g.sent();
                    setCreateCustomerModalOpen(true);
                    if (singleCustomerResponseData === null || singleCustomerResponseData === void 0 ? void 0 : singleCustomerResponseData.SingleClientOrders) {
                        isLoading.next(false);
                        responseData = singleCustomerResponseData === null || singleCustomerResponseData === void 0 ? void 0 : singleCustomerResponseData.SingleClientOrders;
                        setAddCustomerForm({
                            customer_fname: ((_a = responseData === null || responseData === void 0 ? void 0 : responseData.ClientName) === null || _a === void 0 ? void 0 : _a.split(" ")[0]) || "NA",
                            customer_lname: ((_b = responseData === null || responseData === void 0 ? void 0 : responseData.ClientName) === null || _b === void 0 ? void 0 : _b.split(" ")[1]) || "NA",
                            customer_email: (responseData === null || responseData === void 0 ? void 0 : responseData.CustomerMailid) || "NA",
                            customer_phoneno: (responseData === null || responseData === void 0 ? void 0 : responseData.phoneno) ? parseInt(responseData === null || responseData === void 0 ? void 0 : responseData.phoneno) : 0,
                            customer_note: (responseData === null || responseData === void 0 ? void 0 : responseData.notes) || "",
                            customer_address: (responseData === null || responseData === void 0 ? void 0 : responseData.address1) || "",
                            customer_address2: (responseData === null || responseData === void 0 ? void 0 : responseData.address2) || "",
                            customer_city: (_c = responseData === null || responseData === void 0 ? void 0 : responseData.city) !== null && _c !== void 0 ? _c : "",
                            customer_country: (_d = responseData === null || responseData === void 0 ? void 0 : responseData.country) !== null && _d !== void 0 ? _d : "",
                            customer_state: (_e = responseData === null || responseData === void 0 ? void 0 : responseData.province) !== null && _e !== void 0 ? _e : "",
                            customer_pincode: (_f = responseData === null || responseData === void 0 ? void 0 : responseData.zip) !== null && _f !== void 0 ? _f : 0,
                            business_name: (responseData === null || responseData === void 0 ? void 0 : responseData.companyName) || "",
                            cust_company_address: (responseData === null || responseData === void 0 ? void 0 : responseData.companyaddress) || "",
                            cust_company_city: (responseData === null || responseData === void 0 ? void 0 : responseData.companycity) || "",
                            cust_company_country: (responseData === null || responseData === void 0 ? void 0 : responseData.companycountry) || "",
                            cust_company_state: (responseData === null || responseData === void 0 ? void 0 : responseData.companystate) || "",
                            cust_company_pincode: (responseData === null || responseData === void 0 ? void 0 : responseData.companypincode) || 0,
                            subTotal: responseData === null || responseData === void 0 ? void 0 : responseData.shopifyTotalSpent,
                            noOfOrders: responseData === null || responseData === void 0 ? void 0 : responseData.shopifyOrdersCount,
                            tags: (responseData === null || responseData === void 0 ? void 0 : responseData.tags) || "",
                            addressId: responseData === null || responseData === void 0 ? void 0 : responseData.addressId,
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var submitCustomerData = function () { return __awaiter(_this, void 0, void 0, function () {
        var requiredFields, hasValidationErrors, addedCustomerData, responseData, createdCustomerInfo_1;
        var _this = this;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    // Highlight required fields and validate them
                    setHighlightRequiredFields(true);
                    requiredFields = ["customer_fname", "customer_email"];
                    hasValidationErrors = false;
                    requiredFields.forEach(function (fieldName) {
                        var currentFieldValue = addCustomerForm[fieldName];
                        if (!currentFieldValue || currentFieldValue === "") {
                            hasValidationErrors = true;
                            if (fieldName === "customer_fname") {
                                setInputState(function (prev) { return (__assign(__assign({}, prev), { fnameErrMsg: t("addCustomer_leadEmptyErrrorMsg") })); });
                            }
                            else if (fieldName === "customer_email") {
                                var emailError_1 = t("addCustomer_leadEmptyErrrorMsg");
                                setInputState(function (prev) { return (__assign(__assign({}, prev), { emailErrMsg: emailError_1 })); });
                            }
                        }
                    });
                    // If there are validation errors, don't proceed with submission
                    if (hasValidationErrors) {
                        return [2 /*return*/];
                    }
                    setSubmitLoader(true);
                    setAddCustomerErr("");
                    setAlertErrorMsg({ msg: "", open: false, severity: "success" });
                    addedCustomerData = {
                        firstname: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_fname,
                        lastname: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_lname,
                        phoneno: (addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_phoneno) === 0 ? "" : addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_phoneno,
                        email: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_email,
                        note: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_note,
                        address: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_address,
                        address2: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_address2,
                        customercity: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_city,
                        customerstate: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_state,
                        customercountry: (_a = addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_country) === null || _a === void 0 ? void 0 : _a.split("_")[1],
                        customerpincode: (addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_pincode) === "" ? "" : addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_pincode,
                        companyaddress: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.cust_company_address,
                        companycity: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.cust_company_city,
                        companystate: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.cust_company_state,
                        companycountry: (_b = addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.cust_company_country) === null || _b === void 0 ? void 0 : _b.split("_")[1],
                        companypincode: (addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.cust_company_pincode) === 0 ? "" : addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.cust_company_pincode,
                        CustomerCompanyName: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.business_name,
                        tags: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.tags,
                    };
                    return [4 /*yield*/, dispatch(addCustomerData(addedCustomerData))];
                case 1:
                    responseData = _c.sent();
                    setSubmitLoader(false);
                    if (!(responseData === "This customer is already assigned to you.")) return [3 /*break*/, 2];
                    setAlertErrorMsg({ msg: responseData, open: true, severity: "error" });
                    return [3 /*break*/, 5];
                case 2:
                    if (!(responseData === "Customer sucessfully tagged to a rep." ||
                        responseData === "Customer already exists and has been successfully tagged to you." ||
                        responseData === "The customer has been successfully assigned to you." ||
                        responseData === "Customer account created successfully.")) return [3 /*break*/, 4];
                    createdCustomerInfo_1 = {
                        email: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_email,
                        firstName: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_fname,
                        lastName: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_lname,
                        companyName: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.business_name,
                        phone: (addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_phoneno) === 0 ? "" : addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_phoneno,
                    };
                    setAddCustomerForm(defaultFormValues);
                    setHighlightRequiredFields(false);
                    setInputState({ fnameErrMsg: "", emailErrMsg: "", customerPinCodeErrMsg: "", companyPinCodeErrMsg: "" });
                    if ((props === null || props === void 0 ? void 0 : props.indexFrom) == 3) {
                        setAddCustomerSuccess("Customer added successfully. Updating list, please wait... Do not close the modal.");
                    }
                    else {
                        setAlertErrorMsg({ msg: responseData, open: true, severity: "success" });
                    }
                    return [4 /*yield*/, dispatch(getSalesRepBaseData())];
                case 3:
                    _c.sent();
                    // Skill for new server paginated customer list
                    // if (props?.indexFrom == 2) {
                    // 	props?.setCustomerArray(store.getState().salesRepData.baseData.ClientOrders);
                    // 	props?.setAllCustomerCounts(store.getState().salesRepData?.baseData?.ClientOrders?.length ?? 0);
                    // }
                    // Close pop-up for all success messages
                    setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    handleNewCustomerModal();
                                    if (!((props === null || props === void 0 ? void 0 : props.indexFrom) == 1)) return [3 /*break*/, 3];
                                    if (!(typeof (props === null || props === void 0 ? void 0 : props.onCustomerCreated) === "function" && createdCustomerInfo_1.email)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, props.onCustomerCreated(createdCustomerInfo_1)];
                                case 1:
                                    _a.sent();
                                    return [3 /*break*/, 3];
                                case 2:
                                    props === null || props === void 0 ? void 0 : props.EmptyAllFieldsOnSuccess();
                                    _a.label = 3;
                                case 3:
                                    if (!((props === null || props === void 0 ? void 0 : props.indexFrom) == 2 && typeof (props === null || props === void 0 ? void 0 : props.onCustomerAdded) === "function")) return [3 /*break*/, 5];
                                    return [4 /*yield*/, props.onCustomerAdded()];
                                case 4:
                                    _a.sent();
                                    _a.label = 5;
                                case 5:
                                    if (!((props === null || props === void 0 ? void 0 : props.indexFrom) == 3)) return [3 /*break*/, 7];
                                    return [4 /*yield*/, dispatch(getCustomerListWithMainContact("1", true))];
                                case 6:
                                    _a.sent();
                                    _a.label = 7;
                                case 7: return [2 /*return*/];
                            }
                        });
                    }); }, 2000);
                    return [3 /*break*/, 5];
                case 4:
                    if (responseData === "phone Enter a valid phone number to use this delivery method") {
                        setAlertErrorMsg({ msg: t("addCustomer_ErrorMsgOnSubmitBtn"), open: true, severity: "error" });
                    }
                    else {
                        setAlertErrorMsg({ msg: responseData, open: true, severity: "error" });
                    }
                    _c.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var UpdateCustomerData = function () { return __awaiter(_this, void 0, void 0, function () {
        var UpdatedCustomerData, responseData, error_1;
        var _this = this;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    setSubmitLoader(true);
                    setAddCustomerErr("");
                    setAlertErrorMsg({ msg: "", open: false, severity: "error" });
                    UpdatedCustomerData = {
                        firstName: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_fname,
                        lastName: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_lname,
                        phone: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_phoneno,
                        email: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_email,
                        note: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_note,
                        address1: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_address,
                        address2: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_address2,
                        city: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_city,
                        province: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_state,
                        country: (_a = addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_country) === null || _a === void 0 ? void 0 : _a.split("_")[1],
                        zip: (addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_pincode) === "" ? "" : addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.customer_pincode,
                        company: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.business_name,
                        tags: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.tags,
                        custId: props === null || props === void 0 ? void 0 : props.singleCustomerId,
                        salesRepId: salesRepId,
                        addressId: addCustomerForm === null || addCustomerForm === void 0 ? void 0 : addCustomerForm.addressId,
                        isUpdated: true,
                    };
                    return [4 /*yield*/, updateExistingCustomerDataService(UpdatedCustomerData)];
                case 1:
                    responseData = _b.sent();
                    if (responseData) {
                        setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                handleNewCustomerModal();
                                return [2 /*return*/];
                            });
                        }); }, 2000);
                        setAlertErrorMsg({ msg: "Customer info updated successfully!", open: true, severity: "success" });
                    }
                    else {
                        setAlertErrorMsg({ msg: t("addCustomer_leadErrrorMsg"), open: true, severity: "error" });
                    }
                    setSubmitLoader(false);
                    setIsEditForm(true);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    console.log("Error in UpdateCustomerData", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleNewCustomerModal = function () {
        setCreateCustomerModalOpen(!createCustomerModalOpen);
        props === null || props === void 0 ? void 0 : props.closeModal();
    };
    var tagsArray = (addCustomerForm.tags || "")
        .split(",")
        .map(function (tag) { return tag.trim(); })
        .filter(function (tag) { return tag; });
    var handleTagSelect = function (_event, newValue) {
        try {
            setIsEditForm(false);
            var uniqueTags_1 = Array.from(new Set(newValue.map(function (tag) { return tag === null || tag === void 0 ? void 0 : tag.trim(); })));
            setAddCustomerForm(function (prev) { return (__assign(__assign({}, prev), { tags: uniqueTags_1 === null || uniqueTags_1 === void 0 ? void 0 : uniqueTags_1.join(",") })); });
            setInputValue("");
        }
        catch (error) {
            console.log("Error in handleTagSelect", error);
        }
    };
    var filteredOptions = function () {
        if (inputValue && !tagsArray.includes(inputValue.trim())) {
            return [inputValue.trim()];
        }
        return [];
    };
    var handleAlertMsgClose = function (event, reason) {
        if (reason === "clickaway") {
            return;
        }
        setAlertErrorMsg({ msg: "", open: false });
    };
    return {
        t: t,
        addCustomerForm: addCustomerForm,
        isAddCustomer: isAddCustomer,
        setAddCustomerForm: setAddCustomerForm,
        defaultFormValues: defaultFormValues,
        changeValue: changeValue,
        submitCustomerData: submitCustomerData,
        submitBtnEnabled: submitBtnEnabled,
        inputState: inputState,
        stateByCountry: stateByCountry,
        changeCountry: changeCountry,
        submitDataText: submitDataText,
        addCustomerErr: addCustomerErr,
        hideCompanySection: hideCompanySection,
        customerFullAddress: customerFullAddress,
        provinceStates: provinceStates,
        addCustomerSuccess: addCustomerSuccess,
        submitLoader: submitLoader,
        setCreateCustomerModalOpen: setCreateCustomerModalOpen,
        createCustomerModalOpen: createCustomerModalOpen,
        getSingleCustomerData: getSingleCustomerData,
        handleNewCustomerModal: handleNewCustomerModal,
        setIsAddCustomer: setIsAddCustomer,
        removeMessages: removeMessages,
        UpdateCustomerData: UpdateCustomerData,
        isEditCustomer: isEditCustomer,
        tagsArray: tagsArray,
        handleTagSelect: handleTagSelect,
        inputValue: inputValue,
        setInputValue: setInputValue,
        filteredOptions: filteredOptions,
        isEditForm: isEditForm,
        SnackbarAlertMsg: SnackbarAlertMsg,
        alertErrorMsg: alertErrorMsg,
        handleAlertMsgClose: handleAlertMsgClose,
        highlightRequiredFields: highlightRequiredFields,
    };
}
